import { useTypedParams } from '@sorare/routing';

import { PrizePoolContenderPage } from '@sorare/gameplay/src/pages/PrizePoolContenderPage';

import type { PageParams } from './__generated__/routeParams';

const FootballPrizePoolContenderPage = () => {
  const { leaderboard, contender } = useTypedParams<PageParams>();

  return (
    <PrizePoolContenderPage leaderboard={leaderboard} contender={contender} />
  );
};

export default FootballPrizePoolContenderPage;
